import { DemoBadge } from "@/components/common";

export function PageHeader({ title, subtitle, children, showDemo = true }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-7">
      <div>
        <div className="flex items-center gap-3">
          <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-white">{title}</h1>
          {showDemo && <DemoBadge />}
        </div>
        {subtitle && <p className="mt-1.5 text-sm text-slate-400">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}

export function Panel({ className = "", children, ...rest }) {
  return (
    <div className={`vora-card rounded-2xl ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, accent = "text-white", sub, testid }) {
  return (
    <Panel className="p-5 vora-card-hover" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#4F8CFF]/12 text-[#4F8CFF]">
          <Icon className="h-[18px] w-[18px]" />
        </span>
        {sub && <span className="text-xs text-slate-500">{sub}</span>}
      </div>
      <p className={`mt-4 text-2xl font-semibold tracking-tight ${accent}`}>{value}</p>
      <p className="mt-1 text-sm text-slate-400">{label}</p>
    </Panel>
  );
}
